import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
} from "@angular/core";
import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";
import { environment } from "src/environments/environment";

const isSentryEnabled = environment.sentry.enabled;
const sentryProviders = isSentryEnabled
  ? [
      {
        provide: ErrorHandler,
        useValue: Sentry.createErrorHandler(),
      },
      {
        provide: Sentry.TraceService,
        deps: [Router],
      },
      provideAppInitializer(() => {
        inject(Sentry.TraceService);
      }),
    ]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [provideHttpClient(withInterceptorsFromDi()), ...sentryProviders],
};
